import Vue from "vue";
import App from "./App.vue";
import vuelidate from "vuelidate";
import "./assets/tailwind.css";
import "./assets/vue-multiselect.min.css";

Vue.use(vuelidate);
Vue.config.productionTip = false;
Vue.prototype.$hostname = Vue.config.productionTip
  ? "https://realbowl.it"
  : "https://real.atman.ninja";
Vue.prototype.$restAPIurlRB = Vue.prototype.$hostname + "/wp-json/rb/v2/";
Vue.prototype.$restAPIurlWP = Vue.prototype.$hostname + "/wp-json/wp/v2/";

Vue.filter("capitalize", function(value) {
  if (!value) return "";
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});

new Vue({
  render: (h) => h(App),
}).$mount("#app2");
